import pako from "pako";
import jwt from "jwt-decode"; // Optional: Use this to decode base64 JWTs if needed

export const decompressToken = (token: string) => {
  try {
    const decoded: any = jwt(token);

    // Extract the Base64-encoded compressed data
    const { base64CompressedPayload } = decoded;

    // Decode Base64 to binary
    const compressedData = Uint8Array.from(
      atob(base64CompressedPayload)
        .split("")
        .map((char) => char.charCodeAt(0))
    );

    // Decompress with pako
    const decompressedData = pako.inflate(compressedData, { to: "string" });

    return JSON.parse(decompressedData);
  } catch (error) {
    console.error("Error decompressing token:", error);
    return null;
  }
};
